export const ORDER_ID_PREFIX = "HVO-";
export const ORDER_STATUS_CREATED = "CREATED";
export const ORDER_STATUS_PAID = "PAID";
export const ORDER_STATUS_SHIPPED = "SHIPPED";
export const ORDER_STATUS_DELIVERED = "COMPLETED";
export const ORDER_STATUS_RETURNED = "RETURNED";

export const MINIMUM_ORDER_AMOUNT = 50;